// extracted by mini-css-extract-plugin
export var brand = "_8h-9";
export var compact = "_8h-6";
export var extraSmall = "_8h-7";
export var icon = "_8h-0";
export var large = "_8h-4";
export var light = "_8h-1";
export var medium = "_8h-5";
export var outline = "_8h-b";
export var primaryDark = "_8h-a";
export var primaryLight = "_8h-8";
export var primaryModern = "_8h-c";
export var success = "_8h-2";
export var successSolid = "_8h-3";